import { MutableRefObject, useCallback, useEffect } from "react";

/**
 * Listens to a click event outside of the referenced parameter, the callback parameter will be ran once this condition happens
 *
 * @param callback - Call back to be ran once a click event outside of the referenced parameter happens
 * @param reference - Reference to the element that the click event is being listened to
 * @param removeEventListAfterFirstClick - If true, the event listener will be removed after the first click event outside of the referenced parameter
 *
 * Note: Listens to the mousedown event
 */
export const useClickDetectOutside = (callback: (event: PointerEvent) => void, reference: MutableRefObject<HTMLDivElement>, removeEventListAfterFirstClick = true) => {
    useEffect(
        () => () => {
            document.removeEventListener("mousedown", outsideComponentClickHandler);
        },
        []
    );

    useEffect(() => {
        if (reference.current != null) {
            document.addEventListener("mousedown", outsideComponentClickHandler);
        }
    }, [reference.current]);

    const outsideComponentClickHandler = useCallback(
        (event: PointerEvent) => {
            if (reference.current && !reference.current.contains(event.target as Node)) {
                callback(event);
                if (removeEventListAfterFirstClick) {
                    document.removeEventListener("mousedown", outsideComponentClickHandler);
                }
            }
        },
        [reference.current]
    );
};
